import size from 'lodash/size';
import React from 'react';
import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Field, Formik } from 'formik';

import { checkEmail } from '../../actions/checkEmail.actions';

import TextField from '../../components/CstmTextField';
import MobileTextField from '../../components/MobileTextField';
import ScreenWrapper from '../../components/ScreenWrapper';

import { PAGES } from '../../config/constants';
import { IS_EMAIL, REQUIRED } from '../../constants/validations';

const BorrowerInfo = ({ setPrevPage, submitForm, contacts, showError, showLogin }) => {
  const initialValues = {
    first_name: contacts.first_name || '',
    last_name: contacts.last_name || '',
    mobile: contacts.mobile || '',
    email: contacts.email || '',
  };

  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        Please enter your contact info ?
      </h1>

      <ScreenWrapper step={3}>
        <Formik
          initialValues={initialValues}
          onSubmit={values => {
            submitForm(values);
          }}
          validate={validate}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              {showError === true && (
                <React.Fragment>
                  <Alert severity="error">
                    <AlertTitle>Attention</AlertTitle>
                    User already have a password. Please login
                  </Alert>
                  <br />
                </React.Fragment>
              )}

              <Field
                name="first_name"
                label="First Name of Borrower"
                component={TextField}
                required
              />

              <Field
                name="last_name"
                label="Last Name of Borrower"
                component={TextField}
                required
                style={{ marginTop: 10 }}
              />

              <FormControl
                variant="outlined"
                style={{ marginTop: 15, width: '100%' }}
                id="mobile_formControl"
              >
                <Field
                  name="phone_mobile"
                  label="Mobile # of Borrower *"
                  component={MobileTextField}
                  required
                />
              </FormControl>

              <Field
                name="email"
                label="Email of Borrower"
                component={TextField}
                required
                style={{ marginTop: 10 }}
              />

              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'left' }}>
                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={showLogin}>
                    Login
                  </button>
                </div>
                <div style={{ float: 'right' }}>
                  <button type="button" className="cstm_btn cstm_btn-text" onClick={setPrevPage}>
                    Back
                  </button>

                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                    Next
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const validate = values => {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = REQUIRED;
  }

  if (!values.last_name) {
    errors.last_name = REQUIRED;
  }

  if (!values.phone_mobile) {
    errors.phone_mobile = REQUIRED;
  } else if (size(values.phone_mobile) < 14) {
    errors.phone_mobile = 'Please complete the mobile number';
  }

  const emailAddress = values.email;

  if (!emailAddress) {
    errors.email = REQUIRED;
  } else if (IS_EMAIL.test(emailAddress) === false) {
    errors.email = 'Invalid email format';
  }

  return errors;
};

const mapState = state => {
  return {
    contacts: state.form.contacts,
    showError: state.form.showError,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: 2,
      });
    },
    setContactForm: values => {
      dispatch({
        type: 'SET_FORM_CONTACTS',
        payload: values,
      });
    },
    setLoading: () => {
      dispatch({
        type: 'SET_LOADING',
        payload: true,
      });
    },
    submitForm: values => {
      dispatch(checkEmail(values));
    },
    showLogin: () => {
      dispatch({
        type: 'SET_FORM_ERROR',
        payload: false,
      });

      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.LOGIN,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(BorrowerInfo);



// WEBPACK FOOTER //
// ./src/Screens/BorrowerInfo/index.js